import React from 'react';
import Chart from 'chart.js';

class ChartJSWidget extends React.Component {
  state = { error: false };

  constructor(props) {
    super(props);
    this.chartjs = React.createRef();
  }

  componentDidMount() {
    const { widget, data } = this.props;
    this.renderChart(widget, data);
  }

  renderChart(widget, data) {
    const { settings } = widget;
    const chartjs = settings.chartjs || {};

    const chartElement = this.chartjs.current;

    if (chartElement) {
      try {
        const chartSettings = {
          type: 'bar',
          data,
          options: {
            responsive: true,
          },
          ...chartjs,
        };

        var context = chartElement.getContext('2d');
        new Chart(context, chartSettings);
      } catch (error) {
        console.error(error);
        this.setState({ error: error.message });
      }
    }
  }

  render() {
    if (this.state.error) {
      return <div>Falha ao renderizar os dados.</div>;
    }

    return <canvas ref={this.chartjs} />;
  }
}

export default ChartJSWidget;
